import * as CONFIG from './config';

exports.getIsCheckerOrADEnabled = function () {
    // console.log("getIsCheckerOrADEnabled==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/Customer/isCheckerOrADEnabled')
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getCustomerList = function (id) {
    // console.log("getCustomerList==>", id);
    return new Promise((resolve, reject) => {
        // resolve('{"CommitteeList": [{"id": 10,"name": "Training Customer - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Meeting Attendee","status": "active"},{"id": 23,"name": "Alpha Meeting Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Customer","status": "active"}]}');
        let param = '';
        if (id && id.length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/Customer' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addCustomer = function (objModel) {
    return new Promise((resolve, reject) => {
        //{"committee_name":""}
        if (objModel.id > 0) {
            // console.log("addCustomer UPDATE==>",objModel);
            return CONFIG.httpPut('/Customer', objModel)
                .then(function (response) {
                    // console.log('addCustomer succ==>',response);
                    resolve(response);
                })
                .catch(function (err) {
                    // console.log('addCustomer err==>',err);
                    reject(err);
                });
        }
        else {
            // console.log('addCustomer ADD==>',objModel);
            return CONFIG.httpPost('/Customer', objModel)
                .then(function (response) {
                    // console.log('addCustomer succ==>',response);
                    resolve(response);
                })
                .catch(function (err) {
                    // console.log('addCustomer err==>',err);
                    reject(err);
                });
        }
    });

}


// WEBPACK FOOTER //
// ./api/customerdetails.js